// // Embed Utilities
// // Helper functions for the embeddable chatbot widget

// import { EMBED_CONFIG } from '../configs/EmbedConfig';
// import { v4 as uuidv4 } from 'uuid';

// /**
//  * Get or generate chat ID for iframe session with conditional logic
//  * @param {string} agentId - The agent ID
//  * @param {string} providedChatId - Pre-provided chat ID
//  * @param {object} conditions - Conditions for UUID generation/change
//  * @returns {string} Chat ID (UUID)
//  */
// const getOrGenerateChatId = (agentId, providedChatId, conditions = {}) => {
//   // If explicitly provided and it's not the same as agentId, use it
//   if (providedChatId && providedChatId !== agentId) {
//     console.log('📥 Using provided chat ID:', providedChatId);
//     return providedChatId;
//   }
  
//   // If provided chatId is same as agentId, treat as no chatId provided
//   if (providedChatId === agentId) {
//     console.log('⚠️ Provided chatId same as agentId, generating new UUID instead');
//     providedChatId = null;
//   }
  
//   if (agentId) {
//     const storageKey = `vlm_iframe_chat_${agentId}`;
    
//     try {
//       let existingChatId = sessionStorage.getItem(storageKey);
      
//       // Ensure existing chatId is not same as agentId
//       if (existingChatId === agentId) {
//         console.log('⚠️ Existing chatId same as agentId, clearing and generating new UUID');
//         existingChatId = null;
//         sessionStorage.removeItem(storageKey);
//       }
      
//       // Check if we should force a new UUID based on conditions
//       const shouldGenerateNew = checkConditionsForNewUUID(conditions, existingChatId, agentId);
      
//       // Default behavior: Generate new UUID if no existing session OR conditions require it
//       if (shouldGenerateNew || !existingChatId) {
//         const newChatId = uuidv4();
        
//         // Double-check the new UUID is not the same as agentId (extremely unlikely but safe)
//         if (newChatId === agentId) {
//           console.log('🎲 Regenerating UUID due to collision with agentId');
//           return uuidv4(); // Generate another one
//         }
        
//         sessionStorage.setItem(storageKey, newChatId);
        
//         if (shouldGenerateNew && existingChatId) {
//           console.log('🔄 Generated NEW chat ID due to conditions for agent:', agentId, newChatId);
//           console.log('🔄 Previous chat ID was:', existingChatId);
//           console.log('🔄 Conditions that triggered change:', conditions);
//         } else {
//           console.log('🆕 Generated new chat ID for agent:', agentId, newChatId);
//         }
        
//         return newChatId;
//       } else {
//         console.log('♻️ Using existing chat ID for agent:', agentId, existingChatId);
//         return existingChatId;
//       }
//     } catch (error) {
//       console.warn('Failed to access session storage, using generated UUID:', error);
//       const fallbackChatId = uuidv4();
      
//       // Ensure fallback is not same as agentId
//       if (fallbackChatId === agentId) {
//         return uuidv4();
//       }
      
//       return fallbackChatId;
//     }
//   }
  
//   // Fallback to UUID if no agent ID
//   const fallbackUuid = uuidv4();
//   console.log('🎲 Generated fallback UUID (no agentId):', fallbackUuid);
//   return fallbackUuid;
// };

// /**
//  * Check various conditions to determine if a new UUID should be generated
//  * @param {object} conditions - The conditions to check
//  * @param {string} existingChatId - Current chat ID from storage
//  * @param {string} agentId - The agent ID
//  * @returns {boolean} Whether to generate a new UUID
//  */
// const checkConditionsForNewUUID = (conditions, existingChatId, agentId) => {
//   if (!conditions || typeof conditions !== 'object') {
//     // Default behavior: If no conditions and no existing session, create new UUID
//     if (!existingChatId) {
//       console.log('🆕 No conditions and no existing session, generating new UUID');
//       return true;
//     }
//     return false;
//   }
  
//   // Condition 1: Force new session (always generate new UUID)
//   if (conditions.forceNewSession === true) {
//     console.log('🔄 Condition: forceNewSession = true');
//     return true;
//   }
  
//   // Condition 2: New iframe creation
//   if (conditions.newIframe === true) {
//     console.log('🔄 Condition: newIframe = true');
//     return true;
//   }
  
//   // Condition 3: Iframe maximized for chatting
//   if (conditions.maximizeForChat === true) {
//     console.log('🔄 Condition: maximizeForChat = true');
//     return true;
//   }
  
//   // Condition 4: Auto-detect new iframe (no existing session and iframe context)
//   if (!existingChatId && typeof window !== 'undefined' && window.self !== window.top) {
//     console.log('🔄 Condition: Auto-detected new iframe session (no existing chatId)');
//     return true;
//   }
  
//   // Condition 5: Time-based expiration
//   if (conditions.sessionTimeout && existingChatId) {
//     const sessionTimestampKey = `vlm_iframe_timestamp_${agentId}`;
//     const lastTimestamp = sessionStorage.getItem(sessionTimestampKey);
    
//     if (lastTimestamp) {
//       const timeDiff = Date.now() - parseInt(lastTimestamp);
//       const timeoutMs = conditions.sessionTimeout * 60 * 1000; // Convert minutes to milliseconds
      
//       if (timeDiff > timeoutMs) {
//         console.log(`🔄 Condition: Session timeout exceeded (${conditions.sessionTimeout} minutes)`);
//         return true;
//       }
//     } else {
//       // No timestamp found, set current timestamp
//       sessionStorage.setItem(sessionTimestampKey, Date.now().toString());
//     }
//   }
  
//   // Condition 6: User ID change
//   if (conditions.userId && existingChatId) {
//     const userIdKey = `vlm_iframe_userid_${agentId}`;
//     const storedUserId = sessionStorage.getItem(userIdKey);
    
//     if (storedUserId && storedUserId !== conditions.userId) {
//       console.log('🔄 Condition: User ID changed');
//       sessionStorage.setItem(userIdKey, conditions.userId);
//       return true;
//     } else if (!storedUserId) {
//       sessionStorage.setItem(userIdKey, conditions.userId);
//     }
//   }
  
//   // Condition 7: Domain/Origin change
//   if (conditions.trackOrigin === true && existingChatId) {
//     const originKey = `vlm_iframe_origin_${agentId}`;
//     const storedOrigin = sessionStorage.getItem(originKey);
//     const currentOrigin = window.location.origin;
    
//     if (storedOrigin && storedOrigin !== currentOrigin) {
//       console.log('🔄 Condition: Origin/Domain changed');
//       sessionStorage.setItem(originKey, currentOrigin);
//       return true;
//     } else if (!storedOrigin) {
//       sessionStorage.setItem(originKey, currentOrigin);
//     }
//   }
  
//   // Condition 8: Custom condition function
//   if (typeof conditions.customCondition === 'function') {
//     const customResult = conditions.customCondition(existingChatId, agentId);
//     if (customResult === true) {
//       console.log('🔄 Condition: Custom condition returned true');
//       return true;
//     }
//   }
  
//   // Condition 9: Version/Build change
//   if (conditions.version && existingChatId) {
//     const versionKey = `vlm_iframe_version_${agentId}`;
//     const storedVersion = sessionStorage.getItem(versionKey);
    
//     if (storedVersion && storedVersion !== conditions.version) {
//       console.log('🔄 Condition: Version changed');
//       sessionStorage.setItem(versionKey, conditions.version);
//       return true;
//     } else if (!storedVersion) {
//       sessionStorage.setItem(versionKey, conditions.version);
//     }
//   }
  
//   // Update timestamp if session continues (for timeout tracking)
//   if (conditions.sessionTimeout && existingChatId) {
//     const sessionTimestampKey = `vlm_iframe_timestamp_${agentId}`;
//     sessionStorage.setItem(sessionTimestampKey, Date.now().toString());
//   }
  
//   return false;
// };

// /**
//  * Generate chat ID specifically for iframe usage with proper conditions
//  * @param {string} agentId - The agent ID
//  * @param {string} providedChatId - Pre-provided chat ID
//  * @param {object} customConditions - Custom conditions to merge
//  * @returns {string} Chat ID (UUID)
//  */
// export const generateIframeChatId = (agentId, providedChatId = null, customConditions = {}) => {
//   // Ensure we have proper conditions for iframe usage
//   const conditions = {
//     // Auto-detect if this is a new iframe session
//     newIframe: !sessionStorage.getItem(`vlm_iframe_chat_${agentId}`),
//     // Merge any custom conditions
//     ...customConditions
//   };
  
//   console.log('🗺️ Generating iframe chat ID with conditions:', conditions);
  
//   const chatId = getOrGenerateChatId(agentId, providedChatId, conditions);
  
//   // Validate that chatId is different from agentId
//   if (chatId === agentId) {
//     console.warn('⚠️ Generated chatId matches agentId, forcing new UUID');
//     const newChatId = uuidv4();
    
//     // Store the new UUID
//     if (agentId) {
//       try {
//         sessionStorage.setItem(`vlm_iframe_chat_${agentId}`, newChatId);
//         sessionStorage.setItem(`vlm_iframe_timestamp_${agentId}`, Date.now().toString());
//       } catch (error) {
//         console.warn('Failed to store new chat ID:', error);
//       }
//     }
    
//     return newChatId;
//   }
  
//   return chatId;
// };

// /**
//  * Show confirmation dialog for new session creation
//  * @param {string} reason - Reason for new session
//  * @param {function} onConfirm - Callback when user confirms
//  * @param {function} onCancel - Callback when user cancels
//  * @returns {Promise<boolean>} Always returns true (auto-confirm)
//  */
// export const showNewSessionConfirmation = async (reason = 'new session', onConfirm = null, onCancel = null) => {
//   return new Promise((resolve) => {
//     console.log(`✅ Auto-confirming: Starting ${reason}`);
    
//     // Always proceed with new session creation
//     if (onConfirm && typeof onConfirm === 'function') {
//       onConfirm();
//     }
    
//     // Always resolve with true to proceed with new session
//     resolve(true);
//   });
// };

// /**
//  * Create new iframe with confirmation and UUID generation
//  * @param {string} agentId - The agent ID
//  * @param {object} config - Additional configuration
//  * @param {boolean} askConfirmation - Whether to ask for confirmation
//  * @returns {Promise<string>} New chat ID
//  */
// export const createNewIframeSession = async (agentId, config = {}, askConfirmation = true) => {
//   if (!agentId) {
//     throw new Error('Agent ID is required for new iframe session');
//   }
  
//   console.log('🆕 Creating new iframe session for agent:', agentId);
  
//   // Check if there's an existing session
//   const existingChatId = sessionStorage.getItem(`vlm_iframe_chat_${agentId}`);
  
//   if (existingChatId && askConfirmation) {
//     const userConfirmed = await showNewSessionConfirmation('new iframe session');
    
//     if (!userConfirmed) {
//       console.log('♻️ User chose to continue existing session:', existingChatId);
//       return existingChatId;
//     }
//   }
  
//   // Generate new UUID and reset session
//   const newChatId = resetChatSession(agentId);
  
//   // Store creation reason
//   const creationKey = `vlm_iframe_creation_${agentId}`;
//   sessionStorage.setItem(creationKey, JSON.stringify({
//     reason: 'new_iframe',
//     timestamp: Date.now(),
//     config: config
//   }));
  
//   console.log('🆕 New iframe session created:', newChatId);
//   return newChatId;
// };

// /**
//  * Maximize iframe for chatting with confirmation and UUID generation
//  * @param {string} agentId - The agent ID
//  * @param {object} config - Additional configuration
//  * @param {boolean} askConfirmation - Whether to ask for confirmation
//  * @returns {Promise<string>} Chat ID (new or existing)
//  */
// export const maximizeIframeForChat = async (agentId, config = {}, askConfirmation = true) => {
//   if (!agentId) {
//     throw new Error('Agent ID is required for maximizing iframe');
//   }
  
//   console.log('🔍 Maximizing iframe for chat, agent:', agentId);
  
//   // Check if there's an existing session
//   const existingChatId = sessionStorage.getItem(`vlm_iframe_chat_${agentId}`);
  
//   if (existingChatId && askConfirmation) {
//     const userConfirmed = await showNewSessionConfirmation('maximized chat session');
    
//     if (!userConfirmed) {
//       console.log('♻️ User chose to continue existing session in maximized view:', existingChatId);
//       return existingChatId;
//     }
//   }
  
//   // Generate new UUID for maximized session
//   const newChatId = resetChatSession(agentId);
  
//   // Store maximization reason
//   const maximizeKey = `vlm_iframe_maximize_${agentId}`;
//   sessionStorage.setItem(maximizeKey, JSON.stringify({
//     reason: 'maximize_for_chat',
//     timestamp: Date.now(),
//     config: config,
//     previousChatId: existingChatId
//   }));
  
//   console.log('🔍 Maximized iframe session created:', newChatId);
//   return newChatId;
// };

// /**
//  * Get or generate chat ID with enhanced confirmation support
//  * @param {string} agentId - The agent ID
//  * @param {string} providedChatId - Pre-provided chat ID
//  * @param {object} conditions - Conditions for UUID generation/change
//  * @param {boolean} askConfirmation - Whether to ask for confirmation before creating new UUID
//  * @returns {Promise<string>|string} Chat ID (UUID)
//  */
// export const getOrGenerateChatIdWithConfirmation = async (agentId, providedChatId, conditions = {}, askConfirmation = false) => {
//   // If explicitly provided, use it
//   if (providedChatId) {
//     return providedChatId;
//   }
  
//   if (agentId) {
//     const storageKey = `vlm_iframe_chat_${agentId}`;
    
//     try {
//       let existingChatId = sessionStorage.getItem(storageKey);
      
//       // Check if we should force a new UUID based on conditions
//       const shouldGenerateNew = checkConditionsForNewUUID(conditions, existingChatId, agentId);
      
//       if (shouldGenerateNew) {
//         // If confirmation is required and there's an existing session
//         if (askConfirmation && existingChatId) {
//           const reason = conditions.newIframe ? 'new iframe session' : 
//                         conditions.maximizeForChat ? 'maximized chat session' : 
//                         'new session';
          
//           const userConfirmed = await showNewSessionConfirmation(reason);
          
//           if (!userConfirmed) {
//             console.log('♻️ User chose to continue existing session:', existingChatId);
//             return existingChatId;
//           }
//         }
        
//         // Generate new UUID
//         const newChatId = uuidv4();
//         sessionStorage.setItem(storageKey, newChatId);
        
//         if (existingChatId) {
//           console.log('🔄 Generated NEW chat ID due to conditions for agent:', agentId, newChatId);
//           console.log('🔄 Previous chat ID was:', existingChatId);
//           console.log('🔄 Conditions that triggered change:', conditions);
//         } else {
//           console.log('🆕 Generated new chat ID for agent:', agentId, newChatId);
//         }
        
//         return newChatId;
//       } else if (!existingChatId) {
//         // No existing chat ID, generate new one
//         const newChatId = uuidv4();
//         sessionStorage.setItem(storageKey, newChatId);
//         console.log('🆕 Generated new chat ID for agent:', agentId, newChatId);
//         return newChatId;
//       } else {
//         console.log('♻️ Using existing chat ID for agent:', agentId, existingChatId);
//         return existingChatId;
//       }
//     } catch (error) {
//       console.warn('Failed to access session storage, using generated UUID:', error);
//       return uuidv4();
//     }
//   }
  
//   // Fallback to UUID if no agent ID
//   return uuidv4();
// };

// /**
//  * Manually reset chat session (generates new UUID)
//  * @param {string} agentId - The agent ID
//  * @returns {string} New chat ID
//  */
// export const resetChatSession = (agentId) => {
//   if (!agentId) {
//     console.warn('Cannot reset session: agentId is required');
//     return uuidv4();
//   }
  
//   const storageKey = `vlm_iframe_chat_${agentId}`;
//   const timestampKey = `vlm_iframe_timestamp_${agentId}`;
//   const userIdKey = `vlm_iframe_userid_${agentId}`;
//   const originKey = `vlm_iframe_origin_${agentId}`;
//   const versionKey = `vlm_iframe_version_${agentId}`;
  
//   // Clear all related session data
//   try {
//     sessionStorage.removeItem(storageKey);
//     sessionStorage.removeItem(timestampKey);
//     sessionStorage.removeItem(userIdKey);
//     sessionStorage.removeItem(originKey);
//     sessionStorage.removeItem(versionKey);
    
//     console.log('🗑️ Reset session data for agent:', agentId);
//   } catch (error) {
//     console.warn('Failed to clear session storage:', error);
//   }
  
//   // Generate new UUID
//   const newChatId = uuidv4();
  
//   try {
//     sessionStorage.setItem(storageKey, newChatId);
//     sessionStorage.setItem(timestampKey, Date.now().toString());
//     console.log('🆕 Generated new session after reset for agent:', agentId, newChatId);
//   } catch (error) {
//     console.warn('Failed to save new session data:', error);
//   }
  
//   return newChatId;
// };

// /**
//  * Parse URL parameters for embed configuration
//  */
// export const parseEmbedParams = () => {
//   const params = new URLSearchParams(window.location.search);
//   const config = {};

//   console.log('=== PARSING EMBED PARAMS ===');
//   console.log('Full URL:', window.location.href);
//   console.log('Search params:', window.location.search);
//   console.log('All URL params:', Object.fromEntries(params.entries()));

//   // Basic configuration - agent ID and base URL required
//   if (params.get('agentId')) {
//     config.agentId = params.get('agentId');
//     console.log('Found agentId:', config.agentId);
//   } else {
//     console.log('No agentId found in URL params');
//   }

//   // Base URL for API calls (required for iframe)
//   if (params.get('baseUrl')) {
//     config.baseUrl = params.get('baseUrl');
//     console.log('Found baseUrl:', config.baseUrl);
//   } else {
//     console.log('No baseUrl found in URL params');
//   }

//   if (params.get('token')) {
//     config.token = params.get('token');
//     console.log('Found token:', config.token ? 'Present' : 'Missing');
//   } else {
//     console.log('No token found in URL params');
//   }

//   // Generate or get chat ID with conditional logic
//   const providedChatId = params.get('sessionId') || params.get('chatId');
  
//   // Build conditions object from URL parameters
//   const conditions = {};
  
//   // Force new session condition
//   if (params.get('forceNewSession') === 'true') {
//     conditions.forceNewSession = true;
//   }
  
//   // New iframe creation condition
//   if (params.get('newIframe') === 'true') {
//     conditions.newIframe = true;
//   }
  
//   // Maximize for chat condition
//   if (params.get('maximizeForChat') === 'true') {
//     conditions.maximizeForChat = true;
//   }
  
//   // Session timeout condition (in minutes)
//   if (params.get('sessionTimeout')) {
//     const timeout = parseInt(params.get('sessionTimeout'));
//     if (!isNaN(timeout) && timeout > 0) {
//       conditions.sessionTimeout = timeout;
//     }
//   }
  
//   // User ID condition
//   if (params.get('userId')) {
//     conditions.userId = params.get('userId');
//   }
  
//   // Track origin/domain changes
//   if (params.get('trackOrigin') === 'true') {
//     conditions.trackOrigin = true;
//   }
  
//   // Version/build tracking
//   if (params.get('version')) {
//     conditions.version = params.get('version');
//   }
  
//   // Check if confirmation is requested
//   const askConfirmation = params.get('askConfirmation') === 'true';
  
//   // Generate chat ID with conditions and optional confirmation
//   if (askConfirmation && (conditions.newIframe || conditions.maximizeForChat)) {
//     // For async confirmation, we'll handle this in the component
//     config.needsConfirmation = true;
//     config.confirmationReason = conditions.newIframe ? 'new iframe session' : 
//                                conditions.maximizeForChat ? 'maximized chat session' : 
//                                'new session';
//   }
  
//   // Use specialized iframe chat ID generation to ensure proper UUID handling
//   config.chatId = generateIframeChatId(config.agentId, providedChatId, conditions);
//   config.conditions = conditions;
//   console.log('Final chatId:', config.chatId);
//   console.log('Applied conditions:', conditions);
  
//   // Validate chatId is not same as agentId
//   if (config.chatId === config.agentId) {
//     console.error('⚠️ CRITICAL: chatId matches agentId, regenerating...');
//     config.chatId = uuidv4();
//     console.log('Regenerated chatId:', config.chatId);
//   }
  
//   if (config.needsConfirmation) {
//     console.log('Confirmation required for:', config.confirmationReason);
//   }

//   // Set authentication method to token (JWT only)
//   config.authMethod = 'token';
//   console.log('Final parsed config:', config);
//   console.log('=== END PARSING EMBED PARAMS ===');

//   // Widget appearance
//   if (params.get('width')) config.width = params.get('width');
//   if (params.get('height')) config.height = params.get('height');
//   if (params.get('theme')) {
//     // Only support 'default' and 'minimal' themes
//     const theme = params.get('theme').toLowerCase();
//     config.theme = ['default', 'minimal'].includes(theme) ? theme : 'default';
//   }
//   if (params.get('position')) config.position = params.get('position');

//   // Colors
//   if (params.get('primaryColor')) config.primaryColor = params.get('primaryColor');
//   if (params.get('backgroundColor')) config.backgroundColor = params.get('backgroundColor');
//   if (params.get('textColor')) config.textColor = params.get('textColor');

//   // Features
//   if (params.get('showTimestamps')) config.showTimestamps = params.get('showTimestamps') === 'true';
//   if (params.get('allowMinimize')) config.allowMinimize = params.get('allowMinimize') === 'true';
//   if (params.get('showPoweredBy')) config.showPoweredBy = params.get('showPoweredBy') === 'true';

//   // Welcome message
//   if (params.get('welcomeMessage')) config.welcomeMessage = decodeURIComponent(params.get('welcomeMessage'));
//   if (params.get('placeholder')) config.placeholder = decodeURIComponent(params.get('placeholder'));

//   return config;
// };
// Embed Utilities
// Helper functions for the embeddable chatbot widget

import { EMBED_CONFIG } from '../configs/EmbedConfig';
import { v4 as uuidv4 } from 'uuid';

// ============================================================================
// HELPER FUNCTIONS (SonarQube fix - reduce cognitive complexity)
// ============================================================================

/**
 * Helper function to get confirmation reason from conditions (SonarQube fix - extract nested ternary)
 * @param {object} conditions - The conditions object
 * @returns {string} Reason for confirmation
 */
const getConfirmationReason = (conditions) => {
  if (conditions.newIframe) {
    return 'new iframe session';
  }
  if (conditions.maximizeForChat) {
    return 'maximized chat session';
  }
  return 'new session';
};

/**
 * Helper function to validate and sanitize provided chat ID (SonarQube fix)
 * @param {string} providedChatId - The provided chat ID
 * @param {string} agentId - The agent ID
 * @returns {string|null} Sanitized chat ID or null
 */
const validateProvidedChatId = (providedChatId, agentId) => {
  if (providedChatId && providedChatId !== agentId) {
    console.log('📥 Using provided chat ID:', providedChatId);
    return providedChatId;
  }
  
  if (providedChatId === agentId) {
    console.log('⚠️ Provided chatId same as agentId, generating new UUID instead');
    return null;
  }
  
  return providedChatId;
};

/**
 * Helper function to validate existing chat ID from storage (SonarQube fix)
 * @param {string} existingChatId - The existing chat ID
 * @param {string} agentId - The agent ID
 * @param {string} storageKey - The storage key
 * @returns {string|null} Validated chat ID or null
 */
const validateExistingChatId = (existingChatId, agentId, storageKey) => {
  if (existingChatId === agentId) {
    console.log('⚠️ Existing chatId same as agentId, clearing and generating new UUID');
    sessionStorage.removeItem(storageKey);
    return null;
  }
  return existingChatId;
};

/**
 * Helper function to generate a safe UUID (not matching agentId) (SonarQube fix)
 * @param {string} agentId - The agent ID to avoid collision with
 * @returns {string} Safe UUID
 */
const generateSafeUUID = (agentId) => {
  const newChatId = uuidv4();
  if (newChatId === agentId) {
    console.log('🎲 Regenerating UUID due to collision with agentId');
    return uuidv4();
  }
  return newChatId;
};

/**
 * Helper function to store and log new chat ID (SonarQube fix)
 * @param {string} storageKey - The storage key
 * @param {string} newChatId - The new chat ID
 * @param {string} agentId - The agent ID
 * @param {boolean} shouldGenerateNew - Whether conditions required new UUID
 * @param {string|null} existingChatId - The previous chat ID
 * @param {object} conditions - The conditions that triggered change
 */
const storeAndLogNewChatId = (storageKey, newChatId, agentId, shouldGenerateNew, existingChatId, conditions) => {
  sessionStorage.setItem(storageKey, newChatId);
  
  if (shouldGenerateNew && existingChatId) {
    console.log('🔄 Generated NEW chat ID due to conditions for agent:', agentId, newChatId);
    console.log('🔄 Previous chat ID was:', existingChatId);
    console.log('🔄 Conditions that triggered change:', conditions);
  } else {
    console.log('🆕 Generated new chat ID for agent:', agentId, newChatId);
  }
};

/**
 * Helper function to handle session storage error (SonarQube fix)
 * @param {string} agentId - The agent ID
 * @returns {string} Fallback UUID
 */
const handleStorageError = (agentId) => {
  console.warn('Failed to access session storage, using generated UUID');
  const fallbackChatId = uuidv4();
  
  if (fallbackChatId === agentId) {
    return uuidv4();
  }
  
  return fallbackChatId;
};

/**
 * Helper function to handle session timeout condition (SonarQube fix)
 * @param {object} conditions - The conditions object
 * @param {string} existingChatId - Current chat ID
 * @param {string} agentId - The agent ID
 * @returns {boolean} Whether timeout condition triggers new UUID
 */
const checkSessionTimeout = (conditions, existingChatId, agentId) => {
  if (!conditions.sessionTimeout || !existingChatId) {
    return false;
  }
  
  const sessionTimestampKey = `vlm_iframe_timestamp_${agentId}`;
  const lastTimestamp = sessionStorage.getItem(sessionTimestampKey);
  
  if (lastTimestamp) {
    const timeDiff = Date.now() - parseInt(lastTimestamp);
    const timeoutMs = conditions.sessionTimeout * 60 * 1000;
    
    if (timeDiff > timeoutMs) {
      console.log(`🔄 Condition: Session timeout exceeded (${conditions.sessionTimeout} minutes)`);
      return true;
    }
  } else {
    sessionStorage.setItem(sessionTimestampKey, Date.now().toString());
  }
  
  return false;
};

/**
 * Helper function to handle user ID change condition (SonarQube fix)
 * @param {object} conditions - The conditions object
 * @param {string} existingChatId - Current chat ID
 * @param {string} agentId - The agent ID
 * @returns {boolean} Whether user ID change triggers new UUID
 */
const checkUserIdChange = (conditions, existingChatId, agentId) => {
  if (!conditions.userId || !existingChatId) {
    return false;
  }
  
  const userIdKey = `vlm_iframe_userid_${agentId}`;
  const storedUserId = sessionStorage.getItem(userIdKey);
  
  if (storedUserId && storedUserId !== conditions.userId) {
    console.log('🔄 Condition: User ID changed');
    sessionStorage.setItem(userIdKey, conditions.userId);
    return true;
  } else if (!storedUserId) {
    sessionStorage.setItem(userIdKey, conditions.userId);
  }
  
  return false;
};

/**
 * Helper function to handle origin change condition (SonarQube fix)
 * @param {object} conditions - The conditions object
 * @param {string} existingChatId - Current chat ID
 * @param {string} agentId - The agent ID
 * @returns {boolean} Whether origin change triggers new UUID
 */
const checkOriginChange = (conditions, existingChatId, agentId) => {
  if (conditions.trackOrigin !== true || !existingChatId) {
    return false;
  }
  
  const originKey = `vlm_iframe_origin_${agentId}`;
  const storedOrigin = sessionStorage.getItem(originKey);
  const currentOrigin = window.location.origin;
  
  if (storedOrigin && storedOrigin !== currentOrigin) {
    console.log('🔄 Condition: Origin/Domain changed');
    sessionStorage.setItem(originKey, currentOrigin);
    return true;
  } else if (!storedOrigin) {
    sessionStorage.setItem(originKey, currentOrigin);
  }
  
  return false;
};

/**
 * Helper function to handle version change condition (SonarQube fix)
 * @param {object} conditions - The conditions object
 * @param {string} existingChatId - Current chat ID
 * @param {string} agentId - The agent ID
 * @returns {boolean} Whether version change triggers new UUID
 */
const checkVersionChange = (conditions, existingChatId, agentId) => {
  if (!conditions.version || !existingChatId) {
    return false;
  }
  
  const versionKey = `vlm_iframe_version_${agentId}`;
  const storedVersion = sessionStorage.getItem(versionKey);
  
  if (storedVersion && storedVersion !== conditions.version) {
    console.log('🔄 Condition: Version changed');
    sessionStorage.setItem(versionKey, conditions.version);
    return true;
  } else if (!storedVersion) {
    sessionStorage.setItem(versionKey, conditions.version);
  }
  
  return false;
};

/**
 * Get or generate chat ID for iframe session with conditional logic
 * @param {string} agentId - The agent ID
 * @param {string} providedChatId - Pre-provided chat ID
 * @param {object} conditions - Conditions for UUID generation/change
 * @returns {string} Chat ID (UUID)
 */
const getOrGenerateChatId = (agentId, providedChatId, conditions = {}) => {
  // Validate provided chat ID (SonarQube fix - extracted to helper)
  const validatedProvidedChatId = validateProvidedChatId(providedChatId, agentId);
  if (validatedProvidedChatId) {
    return validatedProvidedChatId;
  }
  
  if (!agentId) {
    const fallbackUuid = uuidv4();
    console.log('🎲 Generated fallback UUID (no agentId):', fallbackUuid);
    return fallbackUuid;
  }
  
  const storageKey = `vlm_iframe_chat_${agentId}`;
  
  try {
    let existingChatId = sessionStorage.getItem(storageKey);
    
    // Validate existing chat ID (SonarQube fix - extracted to helper)
    existingChatId = validateExistingChatId(existingChatId, agentId, storageKey);
    
    // Check if we should force a new UUID based on conditions
    const shouldGenerateNew = checkConditionsForNewUUID(conditions, existingChatId, agentId);
    
    // Default behavior: Generate new UUID if no existing session OR conditions require it
    if (shouldGenerateNew || !existingChatId) {
      const newChatId = generateSafeUUID(agentId);
      
      // Store and log (SonarQube fix - extracted to helper)
      storeAndLogNewChatId(storageKey, newChatId, agentId, shouldGenerateNew, existingChatId, conditions);
      
      return newChatId;
    }
    
    console.log('♻️ Using existing chat ID for agent:', agentId, existingChatId);
    return existingChatId;
  } catch (error) {
    return handleStorageError(agentId);
  }
};

/**
 * Check various conditions to determine if a new UUID should be generated
 * @param {object} conditions - The conditions to check
 * @param {string} existingChatId - Current chat ID from storage
 * @param {string} agentId - The agent ID
 * @returns {boolean} Whether to generate a new UUID
 */
const checkConditionsForNewUUID = (conditions, existingChatId, agentId) => {
  if (!conditions || typeof conditions !== 'object') {
    if (!existingChatId) {
      console.log('🆕 No conditions and no existing session, generating new UUID');
      return true;
    }
    return false;
  }
  
  // Condition 1: Force new session (SonarQube fix - early returns reduce complexity)
  if (conditions.forceNewSession === true) {
    console.log('🔄 Condition: forceNewSession = true');
    return true;
  }
  
  // Condition 2: New iframe creation
  if (conditions.newIframe === true) {
    console.log('🔄 Condition: newIframe = true');
    return true;
  }
  
  // Condition 3: Iframe maximized for chatting
  if (conditions.maximizeForChat === true) {
    console.log('🔄 Condition: maximizeForChat = true');
    return true;
  }
  
  // Condition 4: Auto-detect new iframe (no existing session and iframe context)
  if (!existingChatId && typeof window !== 'undefined' && window.self !== window.top) {
    console.log('🔄 Condition: Auto-detected new iframe session (no existing chatId)');
    return true;
  }
  
  // Condition 5: Time-based expiration (SonarQube fix - extracted to helper)
  if (checkSessionTimeout(conditions, existingChatId, agentId)) {
    return true;
  }
  
  // Condition 6: User ID change (SonarQube fix - extracted to helper)
  if (checkUserIdChange(conditions, existingChatId, agentId)) {
    return true;
  }
  
  // Condition 7: Domain/Origin change (SonarQube fix - extracted to helper)
  if (checkOriginChange(conditions, existingChatId, agentId)) {
    return true;
  }
  
  // Condition 8: Custom condition function
  if (typeof conditions.customCondition === 'function') {
    const customResult = conditions.customCondition(existingChatId, agentId);
    if (customResult === true) {
      console.log('🔄 Condition: Custom condition returned true');
      return true;
    }
  }
  
  // Condition 9: Version/Build change (SonarQube fix - extracted to helper)
  if (checkVersionChange(conditions, existingChatId, agentId)) {
    return true;
  }
  
  // Update timestamp if session continues (for timeout tracking)
  if (conditions.sessionTimeout && existingChatId) {
    const sessionTimestampKey = `vlm_iframe_timestamp_${agentId}`;
    sessionStorage.setItem(sessionTimestampKey, Date.now().toString());
  }
  
  return false;
};

/**
 * Generate chat ID specifically for iframe usage with proper conditions
 * @param {string} agentId - The agent ID
 * @param {string} providedChatId - Pre-provided chat ID
 * @param {object} customConditions - Custom conditions to merge
 * @returns {string} Chat ID (UUID)
 */
export const generateIframeChatId = (agentId, providedChatId = null, customConditions = {}) => {
  // Ensure we have proper conditions for iframe usage
  const conditions = {
    // Auto-detect if this is a new iframe session
    newIframe: !sessionStorage.getItem(`vlm_iframe_chat_${agentId}`),
    // Merge any custom conditions
    ...customConditions
  };
  
  console.log('🗺️ Generating iframe chat ID with conditions:', conditions);
  
  const chatId = getOrGenerateChatId(agentId, providedChatId, conditions);
  
  // Validate that chatId is different from agentId
  if (chatId === agentId) {
    console.warn('⚠️ Generated chatId matches agentId, forcing new UUID');
    const newChatId = uuidv4();
    
    // Store the new UUID
    if (agentId) {
      try {
        sessionStorage.setItem(`vlm_iframe_chat_${agentId}`, newChatId);
        sessionStorage.setItem(`vlm_iframe_timestamp_${agentId}`, Date.now().toString());
      } catch (error) {
        console.warn('Failed to store new chat ID:', error);
      }
    }
    
    return newChatId;
  }
  
  return chatId;
};

/**
 * Show confirmation dialog for new session creation
 * @param {string} reason - Reason for new session
 * @param {function} onConfirm - Callback when user confirms
 * @param {function} onCancel - Callback when user cancels
 * @returns {Promise<boolean>} Always returns true (auto-confirm)
 */
export const showNewSessionConfirmation = async (reason = 'new session', onConfirm = null, onCancel = null) => {
  return new Promise((resolve) => {
    console.log(`✅ Auto-confirming: Starting ${reason}`);
    
    // Always proceed with new session creation
    if (onConfirm && typeof onConfirm === 'function') {
      onConfirm();
    }
    
    // Always resolve with true to proceed with new session
    resolve(true);
  });
};

/**
 * Create new iframe with confirmation and UUID generation
 * @param {string} agentId - The agent ID
 * @param {object} config - Additional configuration
 * @param {boolean} askConfirmation - Whether to ask for confirmation
 * @returns {Promise<string>} New chat ID
 */
export const createNewIframeSession = async (agentId, config = {}, askConfirmation = true) => {
  if (!agentId) {
    throw new Error('Agent ID is required for new iframe session');
  }
  
  console.log('🆕 Creating new iframe session for agent:', agentId);
  
  // Check if there's an existing session
  const existingChatId = sessionStorage.getItem(`vlm_iframe_chat_${agentId}`);
  
  if (existingChatId && askConfirmation) {
    const userConfirmed = await showNewSessionConfirmation('new iframe session');
    
    if (!userConfirmed) {
      console.log('♻️ User chose to continue existing session:', existingChatId);
      return existingChatId;
    }
  }
  
  // Generate new UUID and reset session
  const newChatId = resetChatSession(agentId);
  
  // Store creation reason
  const creationKey = `vlm_iframe_creation_${agentId}`;
  sessionStorage.setItem(creationKey, JSON.stringify({
    reason: 'new_iframe',
    timestamp: Date.now(),
    config: config
  }));
  
  console.log('🆕 New iframe session created:', newChatId);
  return newChatId;
};

/**
 * Maximize iframe for chatting with confirmation and UUID generation
 * @param {string} agentId - The agent ID
 * @param {object} config - Additional configuration
 * @param {boolean} askConfirmation - Whether to ask for confirmation
 * @returns {Promise<string>} Chat ID (new or existing)
 */
export const maximizeIframeForChat = async (agentId, config = {}, askConfirmation = true) => {
  if (!agentId) {
    throw new Error('Agent ID is required for maximizing iframe');
  }
  
  console.log('🔍 Maximizing iframe for chat, agent:', agentId);
  
  // Check if there's an existing session
  const existingChatId = sessionStorage.getItem(`vlm_iframe_chat_${agentId}`);
  
  if (existingChatId && askConfirmation) {
    const userConfirmed = await showNewSessionConfirmation('maximized chat session');
    
    if (!userConfirmed) {
      console.log('♻️ User chose to continue existing session in maximized view:', existingChatId);
      return existingChatId;
    }
  }
  
  // Generate new UUID for maximized session
  const newChatId = resetChatSession(agentId);
  
  // Store maximization reason
  const maximizeKey = `vlm_iframe_maximize_${agentId}`;
  sessionStorage.setItem(maximizeKey, JSON.stringify({
    reason: 'maximize_for_chat',
    timestamp: Date.now(),
    config: config,
    previousChatId: existingChatId
  }));
  
  console.log('🔍 Maximized iframe session created:', newChatId);
  return newChatId;
};

/**
 * Helper function to handle confirmation and generate new UUID (SonarQube fix)
 * @param {string} storageKey - The storage key
 * @param {string} agentId - The agent ID
 * @param {object} conditions - The conditions
 * @param {boolean} askConfirmation - Whether to ask confirmation
 * @param {string|null} existingChatId - Existing chat ID
 * @returns {Promise<string>} New chat ID
 */
const handleConfirmationAndGenerate = async (storageKey, agentId, conditions, askConfirmation, existingChatId) => {
  if (askConfirmation && existingChatId) {
    const reason = getConfirmationReason(conditions); // SonarQube fix - use helper
    const userConfirmed = await showNewSessionConfirmation(reason);
    
    if (!userConfirmed) {
      console.log('♻️ User chose to continue existing session:', existingChatId);
      return existingChatId;
    }
  }
  
  const newChatId = uuidv4();
  sessionStorage.setItem(storageKey, newChatId);
  
  if (existingChatId) {
    console.log('🔄 Generated NEW chat ID due to conditions for agent:', agentId, newChatId);
    console.log('🔄 Previous chat ID was:', existingChatId);
    console.log('🔄 Conditions that triggered change:', conditions);
  } else {
    console.log('🆕 Generated new chat ID for agent:', agentId, newChatId);
  }
  
  return newChatId;
};

/**
 * Get or generate chat ID with enhanced confirmation support
 * @param {string} agentId - The agent ID
 * @param {string} providedChatId - Pre-provided chat ID
 * @param {object} conditions - Conditions for UUID generation/change
 * @param {boolean} askConfirmation - Whether to ask for confirmation before creating new UUID
 * @returns {Promise<string>|string} Chat ID (UUID)
 */
export const getOrGenerateChatIdWithConfirmation = async (agentId, providedChatId, conditions = {}, askConfirmation = false) => {
  // If explicitly provided, use it
  if (providedChatId) {
    return providedChatId;
  }
  
  if (!agentId) {
    return uuidv4();
  }
  
  const storageKey = `vlm_iframe_chat_${agentId}`;
  
  try {
    let existingChatId = sessionStorage.getItem(storageKey);
    
    // Check if we should force a new UUID based on conditions
    const shouldGenerateNew = checkConditionsForNewUUID(conditions, existingChatId, agentId);
    
    if (shouldGenerateNew) {
      return await handleConfirmationAndGenerate(storageKey, agentId, conditions, askConfirmation, existingChatId);
    }
    
    if (!existingChatId) {
      const newChatId = uuidv4();
      sessionStorage.setItem(storageKey, newChatId);
      console.log('🆕 Generated new chat ID for agent:', agentId, newChatId);
      return newChatId;
    }
    
    console.log('♻️ Using existing chat ID for agent:', agentId, existingChatId);
    return existingChatId;
  } catch (error) {
    console.warn('Failed to access session storage, using generated UUID:', error);
    return uuidv4();
  }
};

/**
 * Manually reset chat session (generates new UUID)
 * @param {string} agentId - The agent ID
 * @returns {string} New chat ID
 */
export const resetChatSession = (agentId) => {
  if (!agentId) {
    console.warn('Cannot reset session: agentId is required');
    return uuidv4();
  }
  
  const storageKey = `vlm_iframe_chat_${agentId}`;
  const timestampKey = `vlm_iframe_timestamp_${agentId}`;
  const userIdKey = `vlm_iframe_userid_${agentId}`;
  const originKey = `vlm_iframe_origin_${agentId}`;
  const versionKey = `vlm_iframe_version_${agentId}`;
  
  // Clear all related session data
  try {
    sessionStorage.removeItem(storageKey);
    sessionStorage.removeItem(timestampKey);
    sessionStorage.removeItem(userIdKey);
    sessionStorage.removeItem(originKey);
    sessionStorage.removeItem(versionKey);
    
    console.log('🗑️ Reset session data for agent:', agentId);
  } catch (error) {
    console.warn('Failed to clear session storage:', error);
  }
  
  // Generate new UUID
  const newChatId = uuidv4();
  
  try {
    sessionStorage.setItem(storageKey, newChatId);
    sessionStorage.setItem(timestampKey, Date.now().toString());
    console.log('🆕 Generated new session after reset for agent:', agentId, newChatId);
  } catch (error) {
    console.warn('Failed to save new session data:', error);
  }
  
  return newChatId;
};

// ============================================================================
// HELPER FUNCTIONS FOR PARSE EMBED PARAMS (SonarQube fix)
// ============================================================================

/**
 * Helper function to parse basic configuration params (SonarQube fix)
 * @param {URLSearchParams} params - URL search params
 * @param {object} config - Config object to populate
 */
const parseBasicConfig = (params, config) => {
  if (params.get('agentId')) {
    config.agentId = params.get('agentId');
    console.log('Found agentId:', config.agentId);
  } else {
    console.log('No agentId found in URL params');
  }

  if (params.get('baseUrl')) {
    config.baseUrl = params.get('baseUrl');
    console.log('Found baseUrl:', config.baseUrl);
  } else {
    console.log('No baseUrl found in URL params');
  }

  if (params.get('token')) {
    config.token = params.get('token');
    console.log('Found token:', config.token ? 'Present' : 'Missing');
  } else {
    console.log('No token found in URL params');
  }

  const tenantId = params.get('tenantId') || params.get('tenant_id');
  if (tenantId) {
    config.tenantId = tenantId;
    console.log('Found tenantId:', config.tenantId);
  }
};

/**
 * Helper function to parse conditions from URL params (SonarQube fix)
 * @param {URLSearchParams} params - URL search params
 * @returns {object} Conditions object
 */
const parseConditionsFromParams = (params) => {
  const conditions = {};
  
  if (params.get('forceNewSession') === 'true') {
    conditions.forceNewSession = true;
  }
  
  if (params.get('newIframe') === 'true') {
    conditions.newIframe = true;
  }
  
  if (params.get('maximizeForChat') === 'true') {
    conditions.maximizeForChat = true;
  }
  
  if (params.get('sessionTimeout')) {
    const timeout = parseInt(params.get('sessionTimeout'));
    if (!isNaN(timeout) && timeout > 0) {
      conditions.sessionTimeout = timeout;
    }
  }
  
  if (params.get('userId')) {
    conditions.userId = params.get('userId');
  }
  
  if (params.get('trackOrigin') === 'true') {
    conditions.trackOrigin = true;
  }
  
  if (params.get('version')) {
    conditions.version = params.get('version');
  }
  
  return conditions;
};

/**
 * Helper function to parse appearance params (SonarQube fix)
 * @param {URLSearchParams} params - URL search params
 * @param {object} config - Config object to populate
 */
const parseAppearanceParams = (params, config) => {
  if (params.get('width')) config.width = params.get('width');
  if (params.get('height')) config.height = params.get('height');
  
  if (params.get('theme')) {
    const theme = params.get('theme').toLowerCase();
    config.theme = ['default', 'minimal'].includes(theme) ? theme : 'default';
  }
  
  if (params.get('position')) config.position = params.get('position');
};

/**
 * Helper function to parse color params (SonarQube fix)
 * @param {URLSearchParams} params - URL search params
 * @param {object} config - Config object to populate
 */
const parseColorParams = (params, config) => {
  if (params.get('primaryColor')) config.primaryColor = params.get('primaryColor');
  if (params.get('backgroundColor')) config.backgroundColor = params.get('backgroundColor');
  if (params.get('textColor')) config.textColor = params.get('textColor');
};

/**
 * Helper function to parse feature params (SonarQube fix)
 * @param {URLSearchParams} params - URL search params
 * @param {object} config - Config object to populate
 */
const parseFeatureParams = (params, config) => {
  if (params.get('showTimestamps')) config.showTimestamps = params.get('showTimestamps') === 'true';
  if (params.get('allowMinimize')) config.allowMinimize = params.get('allowMinimize') === 'true';
  if (params.get('showPoweredBy')) config.showPoweredBy = params.get('showPoweredBy') === 'true';
};

/**
 * Helper function to parse message params (SonarQube fix)
 * @param {URLSearchParams} params - URL search params
 * @param {object} config - Config object to populate
 */
const parseMessageParams = (params, config) => {
  if (params.get('welcomeMessage')) config.welcomeMessage = decodeURIComponent(params.get('welcomeMessage'));
  if (params.get('placeholder')) config.placeholder = decodeURIComponent(params.get('placeholder'));
  if (params.get('language')) config.language = params.get('language');
};

/**
 * Helper function to handle confirmation logic (SonarQube fix)
 * @param {boolean} askConfirmation - Whether confirmation is requested
 * @param {object} conditions - Conditions object
 * @param {object} config - Config object to populate
 */
const handleConfirmationLogic = (askConfirmation, conditions, config) => {
  if (askConfirmation && (conditions.newIframe || conditions.maximizeForChat)) {
    config.needsConfirmation = true;
    config.confirmationReason = getConfirmationReason(conditions); // SonarQube fix - use helper
  }
};

/**
 * Parse URL parameters for embed configuration
 */
export const parseEmbedParams = () => {
  const params = new URLSearchParams(window.location.search);
  const config = {};

  console.log('=== PARSING EMBED PARAMS ===');
  console.log('Full URL:', window.location.href);
  console.log('Search params:', window.location.search);
  console.log('All URL params:', Object.fromEntries(params.entries()));

  // Parse basic configuration (SonarQube fix - extracted to helper)
  parseBasicConfig(params, config);

  // Generate or get chat ID with conditional logic
  const providedChatId = params.get('sessionId') || params.get('chatId');
  
  // Build conditions object from URL parameters (SonarQube fix - extracted to helper)
  const conditions = parseConditionsFromParams(params);
  
  // Check if confirmation is requested
  const askConfirmation = params.get('askConfirmation') === 'true';
  
  // Generate chat ID with conditions and optional confirmation (SonarQube fix - extracted to helper)
  handleConfirmationLogic(askConfirmation, conditions, config);

  // Use specialized iframe chat ID generation to ensure proper UUID handling
  config.chatId = generateIframeChatId(config.agentId, providedChatId, conditions);
  config.conditions = conditions;
  console.log('Final chatId:', config.chatId);
  console.log('Applied conditions:', conditions);

  // Validate chatId is not same as agentId
  if (config.chatId === config.agentId) {
    console.error('⚠️ CRITICAL: chatId matches agentId, regenerating...');
    config.chatId = uuidv4();
    console.log('Regenerated chatId:', config.chatId);
  }

  if (config.needsConfirmation) {
    console.log('Confirmation required for:', config.confirmationReason);
  }

  // Set authentication method to token (JWT only)
  config.authMethod = 'token';
  console.log('Final parsed config:', config);
  console.log('=== END PARSING EMBED PARAMS ===');

  // Parse appearance params (SonarQube fix - extracted to helper)
  parseAppearanceParams(params, config);

  // Parse color params (SonarQube fix - extracted to helper)
  parseColorParams(params, config);

  // Parse feature params (SonarQube fix - extracted to helper)
  parseFeatureParams(params, config);

  // Parse message params (SonarQube fix - extracted to helper)
  parseMessageParams(params, config);

  return config;
};//added these on 14 nov 2025 commented code is original code

// ... rest of the file remains the same (lines 608-1015) ...
/**
 * Generate embed URL with configuration
 */
export const generateEmbedUrl = (baseUrl, config = {}) => {
  const url = new URL(`${baseUrl}/embed/chat`);
  
  // Add configuration as URL parameters
  Object.entries(config).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      if (typeof value === 'string' && (key === 'welcomeMessage' || key === 'placeholder')) {
        url.searchParams.set(key, encodeURIComponent(value));
      } else {
        url.searchParams.set(key, value.toString());
      }
    }
  });

  return url.toString();
};

/**
 * Generate iframe embed code
 */
export const generateIframeCode = (config = {}) => {
  const {
    agentId,
    sessionId,
    width = EMBED_CONFIG.WIDGET.DEFAULT_WIDTH,
    height = EMBED_CONFIG.WIDGET.DEFAULT_HEIGHT,
    theme = 'default',
    baseUrl = window.location.origin,
    ...otherConfig
  } = config;

  const embedUrl = generateEmbedUrl(baseUrl, {
    agentId,
    sessionId,
    theme,
    ...otherConfig
  });

  return `<iframe
  src="${embedUrl}"
  width="${width}"
  height="${height}"
  frameborder="0"
  style="border: none; border-radius: 12px; box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);"
  allow="microphone"
  title="AI Chatbot">
</iframe>`;
};

/**
 * Generate JavaScript SDK embed code
 */
export const generateJSEmbedCode = (config = {}) => {
  const {
    agentId,
    sessionId,
    position = EMBED_CONFIG.WIDGET.DEFAULT_POSITION,
    theme = 'default',
    baseUrl = window.location.origin,
    ...otherConfig
  } = config;

  const configJson = JSON.stringify({
    agentId,
    sessionId,
    position,
    theme,
    baseUrl,
    ...otherConfig
  }, null, 2);

  return `<!-- VLM Chatbot Widget -->
<script>
  (function() {
    window.VLMChatbotConfig = ${configJson};
    
    var script = document.createElement('script');
    script.src = '${baseUrl}/chatbot-embed.js';
    script.async = true;
    document.head.appendChild(script);
  })();
</script>`;
};

/**
 * Get current chat session info for debugging
 * @param {string} agentId - The agent ID
 * @returns {object} Session information
 */
export const getSessionInfo = (agentId) => {
  if (!agentId) {
    return { error: 'Agent ID is required' };
  }
  
  const storageKey = `vlm_iframe_chat_${agentId}`;
  const timestampKey = `vlm_iframe_timestamp_${agentId}`;
  const userIdKey = `vlm_iframe_userid_${agentId}`;
  const originKey = `vlm_iframe_origin_${agentId}`;
  const versionKey = `vlm_iframe_version_${agentId}`;
  
  try {
    return {
      chatId: sessionStorage.getItem(storageKey),
      timestamp: sessionStorage.getItem(timestampKey),
      userId: sessionStorage.getItem(userIdKey),
      origin: sessionStorage.getItem(originKey),
      version: sessionStorage.getItem(versionKey),
      currentOrigin: window.location.origin,
      agentId: agentId
    };
  } catch (error) {
    return { error: 'Failed to access session storage', details: error.message };
  }
};

/**
 * Check if current session should be renewed based on conditions
 * @param {string} agentId - The agent ID
 * @param {object} conditions - Conditions to check
 * @returns {boolean} Whether session should be renewed
 */
export const shouldRenewSession = (agentId, conditions = {}) => {
  if (!agentId) {
    return false;
  }
  
  const existingChatId = sessionStorage.getItem(`vlm_iframe_chat_${agentId}`);
  return checkConditionsForNewUUID(conditions, existingChatId, agentId);
};

/**
 * Generate message ID using UUID v4
 * @returns {string} Message ID
 */
export const generateMessageId = () => {
  return uuidv4();
};

/**
 * Validate hex color
 */
export const isValidHexColor = (color) => {
  return /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(color);
};

/**
 * Convert hex color to RGB
 */
export const hexToRgb = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
};

/**
 * Generate CSS variables from theme configuration
 */
export const generateThemeCSS = (themeConfig) => {
  const cssVars = [];
  
  if (themeConfig.PRIMARY_COLOR) {
    cssVars.push(`--embed-primary-color: ${themeConfig.PRIMARY_COLOR}`);
  }
  if (themeConfig.BACKGROUND_COLOR) {
    cssVars.push(`--embed-background-color: ${themeConfig.BACKGROUND_COLOR}`);
  }
  if (themeConfig.TEXT_COLOR) {
    cssVars.push(`--embed-text-color: ${themeConfig.TEXT_COLOR}`);
  }
  if (themeConfig.BORDER_COLOR) {
    cssVars.push(`--embed-border-color: ${themeConfig.BORDER_COLOR}`);
  }
  if (themeConfig.BORDER_RADIUS) {
    cssVars.push(`--embed-border-radius: ${themeConfig.BORDER_RADIUS}`);
  }
  if (themeConfig.SHADOW) {
    cssVars.push(`--embed-shadow: ${themeConfig.SHADOW}`);
  }
  if (themeConfig.FONT_FAMILY) {
    cssVars.push(`--embed-font-family: ${themeConfig.FONT_FAMILY}`);
  }

  return cssVars.length > 0 ? `:root { ${cssVars.join('; ')} }` : '';
};

/**
 * Detect if running inside iframe
 */
export const isInIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

/**
 * Get parent window origin safely
 */
export const getParentOrigin = () => {
  try {
    return window.parent.location.origin;
  } catch (e) {
    return '*';
  }
};

/**
 * Post message to parent window
 */
export const postMessageToParent = (type, data = {}) => {
  if (!isInIframe()) return;

  try {
    const message = {
      type: `vlm-chatbot-${type}`,
      data,
      timestamp: Date.now()
    };

    window.parent.postMessage(message, '*');

    // Log for debugging
    console.log('Posted message to parent:', message);
  } catch (error) {
    console.warn('Failed to post message to parent:', error);
  }
};

/**
 * Listen for messages from parent window
 */
export const listenToParentMessages = (callback) => {
  const handleMessage = (event) => {
    if (typeof event.data === 'object' && event.data.type?.startsWith('vlm-chatbot-')) {
      callback(event.data);
    }
  };

  window.addEventListener('message', handleMessage);
  
  return () => {
    window.removeEventListener('message', handleMessage);
  };
};

/**
 * Sanitize HTML content
 */
export const sanitizeHTML = (html) => {
  const div = document.createElement('div');
  div.textContent = html;
  return div.innerHTML;
};

/**
 * Format timestamp for display - simplified to avoid import issues
 */
export const formatTimestamp = (timestamp, showTime = true) => {
  const date = new Date(timestamp);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) {
    return 'Just now';
  } else if (diffMins < 60) {
    return `${diffMins}m ago`;
  } else if (diffHours < 24) {
    return `${diffHours}h ago`;
  } else if (diffDays < 7) {
    return `${diffDays}d ago`;
  } else {
    return showTime
      ? date.toLocaleString()
      : date.toLocaleDateString();
  }
};

/**
 * Debounce function
 */
export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

/**
 * Throttle function
 */
export const throttle = (func, limit) => {
  let inThrottle;
  return function(...args) {
    if (!inThrottle) {
      func.apply(this, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
};

/**
 * Check if device is mobile
 */
export const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

/**
 * Get optimal widget dimensions for device
 */
export const getOptimalDimensions = () => {
  const isMobile = isMobileDevice();
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;

  if (isMobile) {
    return {
      width: Math.min(screenWidth - 40, 360),
      height: Math.min(screenHeight - 100, 500)
    };
  }

  return {
    width: parseInt(EMBED_CONFIG.WIDGET.DEFAULT_WIDTH),
    height: parseInt(EMBED_CONFIG.WIDGET.DEFAULT_HEIGHT)
  };
};

/**
 * Parse API error and return user-friendly message
 * Handles specific API error responses with detail field
 */
export const parseApiError = (error, fallbackMessage = 'Something went wrong. Please try again.') => {
  if (!error) return fallbackMessage;

  // Check for error.data.detail.message (custom API error shape)
  if (error.data?.detail && typeof error.data.detail === 'object' && error.data.detail.message) {
    return error.data.detail.message;
  }

  // Handle different error types based on status code
  if (error.response?.status === 403) {
    // Check if there's a specific detail message from the API
    const apiDetail = error.response?.data?.detail;
    if (apiDetail && typeof apiDetail === 'string') {
      // Use the specific API message for conversation limits and other 403 errors
      return apiDetail;
    } else {
      // Fallback to generic chat unavailable message
      return EMBED_CONFIG.CHAT.ERROR_MESSAGES.CHAT_UNAVAILABLE;
    }
  } else if (error.response?.status === 404) {
    return EMBED_CONFIG.CHAT.ERROR_MESSAGES.AGENT_UNAVAILABLE;
  } else if (error.response?.status === 429) {
    return EMBED_CONFIG.CHAT.ERROR_MESSAGES.RATE_LIMIT;
  } else if (error.response?.status >= 500) {
    return EMBED_CONFIG.CHAT.ERROR_MESSAGES.NETWORK;
  }

  // Check for detail in error data regardless of status code
  const apiDetail = error.response?.data?.detail || error.data?.detail;
  if (apiDetail && typeof apiDetail === 'string') {
    return apiDetail;
  }

  // Fallbacks
  if (error.message) return error.message;
  return fallbackMessage;
};

export default {
  parseEmbedParams,
  generateEmbedUrl,
  generateIframeCode,
  generateJSEmbedCode,
  isValidHexColor,
  hexToRgb,
  generateThemeCSS,
  isInIframe,
  getParentOrigin,
  postMessageToParent,
  listenToParentMessages,
  sanitizeHTML,
  formatTimestamp,
  debounce,
  throttle,
  generateMessageId,
  isMobileDevice,
  getOptimalDimensions,
  parseApiError
};
